var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tour',{attrs:{"name":"data-mapping-tour","steps":_vm.steps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }